export const subscribeFormHandler = () => {
    const trigger = document.querySelector('.jsHeaderSubscribeFormButton');
    const form = document.querySelector('.jsProPopup');
    const overlay = document.querySelector('.jsPopupOverlay');
    const activeClass = 'active';

    if (!trigger && !form) return;

    trigger.addEventListener('click', () => {
        form.classList.add(activeClass);
        overlay.classList.add(activeClass);
    });

    const close = document.querySelector('.jsPopupClose');
    if (!close) return;

    close.addEventListener('click', () => {
        form.classList.remove(activeClass);
        overlay.classList.remove(activeClass);
    });
};